import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface CuratedMessage { id: string; label: string; text: string }
export interface CuratedMessages { options: CuratedMessage[]; facts: string[]; since?: string }

/**
 * AI-written message options for the caller's own menu, led by what changed
 * since the last promotion. Read-only: nothing is sent from here.
 */
export function useCuratedMenuMessages(menuId: string | undefined, mode: 'share' | 'promote', enabled: boolean) {
  return useQuery({
    queryKey: ['curated-menu-messages', menuId, mode],
    enabled: !!menuId && enabled,
    staleTime: 10 * 60_000,
    retry: false,
    queryFn: async (): Promise<CuratedMessages> => {
      const { data, error } = await supabase.functions.invoke('curate-menu-message', {
        body: { menu_id: menuId, mode },
      });
      // Suggestions are optional: on any failure fall back to the written templates.
      if (error) { console.warn('curate-menu-message unavailable', error); return { options: [], facts: [] }; }
      return (data as CuratedMessages) ?? { options: [], facts: [] };
    },
  });
}
